import PropTypes from 'prop-types';
import React from 'react';

import ChannelBar from './components/ChannelBar';
import StoreList from './components/StoreList';

import {
  ChannelLabel,
  ChannelRow,
  ChannelsColumn,
  IdentityColumn,
  IdentityTitle,
  RowContainer,
} from './styledComponents';

const PerformanceRow = ({ row, channels, displayMode, currency, maxPriceExTax }) => (
  <RowContainer>
    <IdentityColumn>
      <IdentityTitle title={row.variantName || row.name}>
        {row.variantName || row.name}
      </IdentityTitle>
      <StoreList storeNames={row.storeNames} />
    </IdentityColumn>
    <ChannelsColumn>
      {channels.map((channel, channelIndex) => {
        const metrics = row.byChannel?.[channel.id] || {};

        return (
          <ChannelRow key={`${row.id}-${channel.id}`}>
            <ChannelLabel>{channel.fullName}</ChannelLabel>
            <ChannelBar
              channelIndex={channelIndex}
              currency={currency}
              displayMode={displayMode}
              maxPriceExTax={maxPriceExTax}
              metrics={metrics}
            />
          </ChannelRow>
        );
      })}
    </ChannelsColumn>
  </RowContainer>
);

PerformanceRow.propTypes = {
  channels: PropTypes.arrayOf(PropTypes.object).isRequired,
  currency: PropTypes.object,
  displayMode: PropTypes.string.isRequired,
  maxPriceExTax: PropTypes.number,
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string,
    variantName: PropTypes.string,
    storeNames: PropTypes.arrayOf(PropTypes.string),
    byChannel: PropTypes.object,
  }).isRequired,
};

PerformanceRow.defaultProps = {
  currency: null,
  maxPriceExTax: null,
};

export default PerformanceRow;
